// Indexer Server Host
export var INDEXER_HOST = "https://spp-indexer.seedao.tech";
// Safe Server Host
export var SAFE_HOST = "https://sns-api.seedao.tech";
// ---> prod environment
// RPCs
export var RPC = "https://polygon-mainnet.g.alchemy.com/v2/-MLinGy2l91vLVZWXmRfNYf9DavMxaEA";
// Deployed Addresses
export var BASE_REGISTRAR_ADDR = "0x5f3BD0CE4445E96F2D7DCC4bbA883378EAD8E10f"; // BaseRegistrar contract address
export var SEEDAO_REGISTRAR_CONTROLLER_ADDR = "0x0E282cfc8c7293CBfDB80E289E19060C4c85cbED"; // SeeDAORegistrarController contract address
export var PUBLIC_RESOLVER_ADDR = "0x64b7CbacE440808C8d71bb62E80A655331ABe092"; // PublicResolver contract address
export var SEEDAO_MINTER_ADDR = "0xd97baE29C72B61142D9D4d148264f31930dFb94F"; // SeeDAOMinter contract address
// // ---> sepolia environment
// export const RPC: string =
//   "https://eth-sepolia.g.alchemy.com/v2/H43zK7UnIN2v7u2ZoTbizIPnXkylKIZl";
// export const BASE_REGISTRAR_ADDR: string =
//   "0xCaF5eC467ecce6f1a43C361848483a88FEb0d5b4";
// export const SEEDAO_REGISTRAR_CONTROLLER_ADDR: string =
//   "0x492b9AF316C81FA1D9aA8F975170E0A7Fcd48092";
// export const PUBLIC_RESOLVER_ADDR: string =
//   "0x46dbAD41324a616938A0Dac717Eb26aFBC1512EC";
// export const SEEDAO_MINTER_ADDR: string =
//   "0xb1a69eb4b8121734Ed6402EEF4aC74a98b212B6F";
// // ==>>>> package.json
// // {
// //   "name": "@seedao/sns-js-sepolia",
// //   "version": "0.1.0",
// // }
// ---> dev environment
// export const INDEXER_HOST: string = "http://localhost:3000";
// export const SAFE_HOST: string = "http://localhost:8090";
// export const RPC: string = "http://127.0.0.1:8545/";
// export const BASE_REGISTRAR_ADDR: string = "";
// export const SEEDAO_REGISTRAR_CONTROLLER_ADDR: string = "";
// export const PUBLIC_RESOLVER_ADDR: string = "";
